import React from "react";
import PropTypes from "prop-types";
import i18next from "i18next";

const Tagline = ({ iconUrl, label, options }) => {
    return (
        <div className="tagline">
            <p className="tagline__text">
                <img src={iconUrl} alt={"tagline"} />
                <span>{i18next.t(label, options)}</span>
            </p>
        </div>
    );
};

Tagline.propTypes = {
    iconUrl: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    options: PropTypes.object,
};
export default Tagline;
